//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
/**@type {import('../types').DataType<import('./types').ContactThreadModel>} */

var CONTACT_DATA_TYPE = {
  data: {
    url: '/backend/contactjourneys/{contactId}',
    // itemUrl: '/backend/contacts?synchronizationId={id}',
    dataKey: 'contactThreads',
    idKeyProp: 'ThreadId',
    onBeforeRequest: function onBeforeRequest(props, request) {
      if (props.dataProps && props.dataProps.contactId && request.url.indexOf('{contactId}') > -1) {
        request.url = request.url.replace('{contactId}', props.dataProps.contactId);
        return request;
      }
    }
  },
  placeholders: {
    label: function label(data) {
      return data.ContactName;
    }
  },
  columns: [// {
  //   id: 'Name',
  //   children: 'Name',
  //   formatter: ({ data }) => (
  //     <Formatter.Text value={data.ContactName} />
  //   ),
  //   serverSort: false,
  //   inMemorySort: false,
  // },
  {
    id: 'Journey',
    children: 'Journey',
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.Text, {
        value: data.JourneyName
      });
    },
    serverSort: false,
    inMemorySort: false
  }, {
    id: 'Enabled',
    children: 'Enabled',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Switch, {
        value: data.JourneyEnabled
      });
    },
    serverSort: false,
    inMemorySort: false
  }]
};
export default CONTACT_DATA_TYPE;